/**
 * @file 常量 - 平台
 * @author hardylin <hardylin@tencent.com>
 */
export default [{
    id: 1,
    name: '热门',
    children: [{
        id: 1,
        name: '大家都在用',
        icon: 'https://moss.oa.com/cloud/images/logo_b29324.svg',
        children: [{
            id: 1,
            name: '投稿服务',
            link: 'http://tgl.oa.com/v3/#/article/create',
            target: '_blank',
        }, {
            id: 2,
            name: '问答活动',
            link: 'http://moss.oa.com/sop/static/#/serviceDocument/ServiceDocumentInfo?serviceid=54',
            target: '_blank',
        }, {
            id: 3,
            name: 'KOL 监测',
            link: 'http://bigv.oa.com/rank/hot',
            target: '_blank',
        }, {
            id: 4,
            name: '精准广告投放',
            link: 'http://o2.qq.com/v2/dist/index.html',
            target: '_blank',
        }, {
            id: 5,
            name: 'API 网关',
            link: 'http://10.213.140.75:8080/luffy/index.html#/traffic/bypass',
            target: '_blank',
        }]
    }, {
        id: 2,
        name: '最新推出',
        icon: 'https://moss.oa.com/cloud/images/logo_b29324.svg',
        children: [{
            id: 1,
            name: 'KOL 游戏用户画像',
            link: 'http://bigv.oa.com/rank/hot',
            target: '_blank',
        }]
    }]
}, {
    id: 2,
    name: '内容营销',
    children: [{
        id: 1,
        name: 'TGL-腾讯游戏玩家联盟',
        desc: '腾讯游戏内容分发平台',
        icon: 'data:image/png;base64,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',
        children: [{
            id: 1,
            name: '投稿服务',
            link: 'http://tgl.oa.com/v3/#/article/create',
            target: '_blank',
        }, {
            id: 2,
            name: '同人业务',
            link: 'http://doujin.oa.com/#/article/index',
            target: '_blank',
        }, {
            id: 3,
            name: '内容管理',
            link: 'http://tgl.oa.com/v3/#/article/verify',
            target: '_blank',
        }, {
            id: 4,
            name: '收益结算',
            link: 'https://tgl.qq.com/activity/#/center/profit/profit',
            target: '_blank',
        }, {
            id: 5,
            name: '热点监控',
            link: 'https://tgl.qq.com/activity/#/center/laboratory/radar/trend',
            target: '_blank',
        }, {
            id: 6,
            name: '素材库',
            link: 'https://tgl.qq.com',
            target: '_blank',
        }]
    }, {
        id: 2,
        name: 'SISA系统',
        desc: '精准评估内容营销效果，开启智慧决策',
        icon: 'https://moss.oa.com/cloud/images/logo_b29324.svg',
        children: [{
            id: 1,
            name: '内容传播',
            link: 'http://zhishu.oa.com/sisaNew',
            icon: 'http://zhishu.oa.com/images/icon-2x-s60f056801e.png',
            target: '_blank',
        }, {
            id: 2,
            name: '效果监测',
            link: 'http://zhishu.oa.com/event/list/product',
            icon: 'http://zhishu.oa.com/images/icon-2x-s60f056801e.png',
            target: '_blank',
        }]
    }]
}, {
    id: 3,
    name: '社区运营',
    children: [{
        id: 1,
        name: '社区业务创建',
        desc: '业务模块自助配置，社区全家桶一站式解决方案',
        icon: 'https://moss.oa.com/cloud/images/logo_b29324.svg',
        children: [{
            id: 1,
            name: '微社区',
            link: 'https://moss.qq.com/sy/main_new#/ingame/tongren/navbar',
            target: '_blank',
        }, {
            id: 2,
            name: '官网',
            link: 'http://mocha.oa.com',
            target: '_blank',
        }, {
            id: 3,
            name: '公众号',
            link: 'http://gzhoss.oa.com/mossv2/awp/',
            target: '_blank',
        }, {
            id: 4,
            name: '电竞通',
            link: 'https://moss.qq.com/sy/main_new#/ingame/match/category',
            target: '_blank',
        }, {
            id: 5,
            name: '论坛',
            link: 'https://bbs.zhuoyao.qq.com/forum.php',
            target: '_blank',
        }, {
            id: 6,
            name: '小程序',
            link: 'https://mp.weixin.qq.com/cgi-bin/wx',
            target: '_blank',
        }, {
            id: 7,
            name: '小游戏',
            link: 'https://developers.weixin.qq.com/minigame/dev/guide/',
            target: '_blank',
        }]
    }, {
        id: 2,
        name: '运营支撑平台',
        desc: '社区业务日常更新维护及数据分析',
        icon: 'https://moss.oa.com/cloud/images/logo_b29324.svg',
        children: [{
            id: 1,
            name: '社区业务平台',
            link: 'https://moss.oa.com/admin/',
            target: '_self',
        }, {
            id: 2,
            name: '社区报表系统',
            link: 'http://mosso.oa.com',
            target: '_blank',
        }, {
            id: 3,
            name: '社区 SDK',
            link: 'http://tapd.oa.com/WSSDK/markdown_wikis/#1020405642009244779',
            target: '_blank',
        }]
    }, {
        id: 3,
        name: '社区活动配置',
        desc: '业务模块自助配置，社区全家桶一站式解决方案',
        icon: 'https://moss.oa.com/cloud/images/logo_b29324.svg',
        children: [{
            id: 1,
            name: '每日运势',
            link: 'http://moss.oa.com/sop/static/#/serviceDocument/ServiceDocumentInfo?serviceid=71',
            icon: 'http://moss.oa.com/sop/static/images/0e9d51d0a60ed503854af0bed3762747.png',
            target: '_blank',
        }, {
            id: 2,
            name: '问答活动',
            link: 'http://moss.oa.com/sop/static/#/serviceDocument/ServiceDocumentInfo?serviceid=54',
            icon: 'http://moss.oa.com/sop/static/images/0e9d51d0a60ed503854af0bed3762747.png',
            target: '_blank',
        }]
    }]
}, {
    id: 4,
    name: '数据营销',
    children: [{
        id: 1,
        name: 'MMS 系统',
        desc: '了解行业，洞察用户，让营销清晰可见',
        icon: 'https://moss.oa.com/cloud/images/logo_b29324.svg',
        children: [{
            id: 1,
            name: '整体研究',
            link: 'http://mms.ied.com/#/month_report/mobile',
            icon: 'http://mms.ied.com/images/hdLogo.png?8081a9313bfe13998f25e0437acd6b92',
            target: '_blank',
        }, {
            id: 2,
            name: '产品数据',
            link: 'http://mms.ied.com/',
            icon: 'http://mms.ied.com/images/hdLogo.png?8081a9313bfe13998f25e0437acd6b92',
            target: '_blank',
        }, {
            id: 3,
            name: '营销工具',
            link: 'http://mms.ied.com/#/profile_spread/profile',
            icon: 'http://mms.ied.com/images/hdLogo.png?8081a9313bfe13998f25e0437acd6b92',
            target: '_blank',
        }]
    }, {
        id: 2,
        name: '大V系统',
        desc: '红人榜单，一网打尽',
        icon: 'data:image/png;base64,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',
        children: [{
            id: 1,
            name: 'KOL 监测',
            link: 'http://bigv.oa.com/rank/hot',
            target: '_blank',
        }, {
            id: 2,
            name: 'KOL 游戏用户画像',
            link: 'http://bigv.oa.com/rank/hot',
            target: '_blank',
        }, {
            id: 3,
            name: 'KOL 效果评估',
            link: 'http://bigv.oa.com/rank/hot',
            target: '_blank',
        }, {
            id: 4,
            name: '点播内容效果评估',
            link: 'http://bigv.oa.com/rank/hot',
            target: '_blank',
        }]
    }, {
        id: 3,
        name: 'DMP',
        desc: '全方位洞察用户，精准挖掘优质潜在用户',
        icon: 'https://moss.oa.com/cloud/images/logo_b29324.svg',
        children: [{
            id: 1,
            name: '用户画像',
            link: 'http://dmp.ied.com/#/comprehensive',
            target: '_blank',
        }, {
            id: 2,
            name: '人群扩散',
            link: 'http://dmp.ied.com/#/spread',
            target: '_blank',
        }, {
            id: 3,
            name: '标签智选',
            link: 'http://dmp.ied.com/#/label',
            target: '_blank',
        }, {
            id: 4,
            name: '官网增长',
            link: 'http://dmp.ied.com/#/growth_analysis',
            target: '_blank',
        }]
    }]
}, {
    id: 5,
    name: '广告投放',
    children: [{
        id: 1,
        name: 'O2 系统',
        desc: 'AI 优化投放方案，精准触达目标受众',
        icon: 'http://hao123.ied.com/images/O2.png',
        children: [{
            id: 1,
            name: '精准广告投放',
            link: 'http://o2.qq.com/v2/dist/index.html',
            target: '_blank',
        }, {
            id: 2,
            name: 'A/B 广告素材测试',
            link: 'http://o2.qq.com/v2/dist/index.html',
            target: '_blank',
        }, {
            id: 3,
            name: '广告智能排期',
            link: 'http://o2.qq.com/v2/dist/index.html',
            target: '_blank',
        }]
    }, {
        id: 2,
        name: 'SEM 系统',
        desc: '提升获客效率',
        icon: 'https://moss.oa.com/cloud/images/logo_b29324.svg',
        children: [{
            id: 1,
            name: '推广工具',
            target: '_blank',
        }, {
            id: 2,
            name: '网站分析',
            target: '_blank',
        }, {
            id: 3,
            name: '基础优化',
            target: '_blank',
        }]
    }]
}, {
    id: 6,
    name: '技术支持',
    children: [{
        id: 1,
        name: '公共基础支持',
        icon: 'http://10.213.140.75:8080/luffy/images/f1195e91eea7c852a0f24602dad72a0a.png',
        children: [{
            id: 1,
            name: 'API 网关',
            link: 'http://10.213.140.75:8080/luffy/index.html#/traffic/bypass',
            target: '_blank',
        }, {
            id: 2,
            name: '调用链跟踪系统',
            target: '_blank',
        }, {
            id: 3,
            name: 'Swoolumen',
            target: '_blank',
        }, {
            id: 4,
            name: 'CP 作业平台',
            link: 'https://moss.qq.com/cpwork/manager/index.php/qiowej/',
            target: '_blank',
        }]
    }, {
        id: 2,
        name: 'ITEA',
        icon: 'https://moss.oa.com/cloud/images/logo_b29324.svg',
        children: [{
            id: 1,
            name: 'Word 导入服务',
            target: '_blank',
        }, {
            id: 2,
            name: '静态文件 CDN',
            target: '_blank',
        }, {
            id: 3,
            name: 'WorkFlow',
            target: '_blank',
        }, {
            id: 4,
            name: '视频格式转换',
            target: '_blank',
        }, {
            id: 5,
            name: '内容 Page 静态化',
            target: '_blank',
        }]
    }, {
        id: 3,
        name: '公共组件',
        icon: 'https://moss.oa.com/cloud/images/logo_b29324.svg',
        children: [{
            id: 1,
            name: '评论组件',
            link: 'https://alltest.ingame.qq.com/comment/docs/mobile/',
            target: '_blank',
        }]
    }]
}, {
    id: 7,
    name: '流程支持',
    children: [{
        id: 1,
        name: 'MSH 系统',
        desc: 'IEG 营销审批全流程覆盖',
        icon: 'data:image/png;base64,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',
        children: [{
            id: 1,
            name: '费用预审',
            link: 'http://msh.oa.com/#/approval/todo/processing',
            target: '_blank',
        }, {
            id: 1,
            name: '立项调整',
            link: 'http://msh.oa.com/#/adjust/todo/processing',
            target: '_blank',
        }, {
            id: 1,
            name: 'brief 管理',
            link: 'http://msh.oa.com/#/brief/todo/processing',
            target: '_blank',
        }]
    }, {
        id: 2,
        name: '供应商管理系统',
        desc: '社区供应商订单管理',
        icon: 'https://moss.oa.com/cloud/images/logo_b29324.svg',
        children: [{
            id: 1,
            name: '需求发起',
            link: 'http://qcp.oa.com/',
            target: '_blank',
        }, {
            id: 2,
            name: '需求审核',
            link: 'http://qcp.oa.com/',
            target: '_blank',
        }, {
            id: 3,
            name: '订单验收',
            link: 'http://qcp.oa.com/',
            target: '_blank',
        }]
    }]
}]